var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stickersheets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Styleguide-/-Logo-/-Colors-/-Typography-/-Buttons-/-Icons-/-Inputs-/-Loaders-/-Checkboxes-/-Tabs-/-Pagination-/-Lables-",
    transform: "translate(-446.000000, -2456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-notifications-eb0e-on",
    transform: "translate(446.000000, 2456.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,19.125 C12.825,19.125 13.5,18.45 13.5,17.625 L10.5,17.625 C10.5,18.45 11.1675,19.125 12,19.125 Z M16.5,14.625 L16.5,10.875 C16.5,8.5725 15.27,6.645 13.125,6.135 L13.125,5.625 C13.125,5.0025 12.6225,4.5 12,4.5 C11.3775,4.5 10.875,5.0025 10.875,5.625 L10.875,6.135 C8.7225,6.645 7.5,8.565 7.5,10.875 L7.5,14.625 L6,16.125 L6,16.875 L18,16.875 L18,16.125 L16.5,14.625 Z",
    id: "Shape",
    fill: "#283049",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    fill: "#C3E27A",
    cx: 17.25,
    cy: 5.25,
    r: 3.75
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsOn);
export default __webpack_public_path__ + "static/media/notifications-on.03b3306f.svg";
export { ForwardRef as ReactComponent };